// Admin-panel sections the platform owner can switch off per business.
// Keys match server/src/utils/features.js.
export const FEATURE_INFO = {
  pos: { name: 'POS', description: 'Point-of-sale screen for counter sales' },
  kitchen: { name: 'Kitchen', description: 'Kitchen display for incoming orders' },
  tables: { name: 'Tables', description: 'Tables and QR codes for dine-in ordering' },
  reservations: { name: 'Reservations', description: 'Table reservations' },
  availability: { name: 'Availability', description: 'Opening hours and closed days' },
  inventory: { name: 'Inventory', description: 'Stock levels and low-stock alerts' },
  shipping: { name: 'Shipping', description: 'Delivery areas and prices' },
  employees: { name: 'Employees', description: 'Staff accounts and PINs' },
  customers: { name: 'Customers', description: 'Customer list and loyalty points' },
  whatsapp: { name: 'WhatsApp', description: 'WhatsApp marketing campaigns' },
  reports: { name: 'Reports', description: 'Sales reports' },
  website: { name: 'Website & Themes', description: 'Storefront themes and design' },
}

// Which feature each admin page belongs to.
export const NAV_FEATURE = {
  '/admin/pos': 'pos',
  '/admin/kitchen': 'kitchen',
  '/admin/tables': 'tables',
  '/admin/reservations': 'reservations',
  '/admin/availability': 'availability',
  '/admin/inventory': 'inventory',
  '/admin/shipping': 'shipping',
  '/admin/employees': 'employees',
  '/admin/customers': 'customers',
  '/admin/whatsapp': 'whatsapp',
  '/admin/reports': 'reports',
  '/admin/website': 'website',
}
